import { findIdToken, reportTokenLostOnLoad } from "$/lib/auth"
import { userQueryOptions } from "$/lib/queries/user-queries"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth")({
  beforeLoad: async ({ location, context: { queryClient } }) => {
    // Await a genuinely usable token rather than checking that localStorage
    // merely holds one. A transient failure throws to the error screen rather
    // than /login, so a network blip never logs out.
    const idToken = await findIdToken()

    if (!idToken) {
      await reportTokenLostOnLoad()

      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      })
    }

    const user = await queryClient.ensureQueryData(userQueryOptions)
    if (!user.isAdmin) throw redirect({ to: "/not-admin" })
  },
})
